import {
  Component,
  Input,
  OnChanges,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import { Subscription } from 'rxjs'
import { Footnote } from 'src/app/models/footnote.model'
import { NavArr, Returns } from 'src/app/models/performance-response.model'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'

@Component({
  selector: 'quarterly-after-tax',
  templateUrl: './quarterly-after-tax.component.html',
  styleUrls: ['./quarterly-after-tax.component.scss'],
  providers: [],
})
export class QuarterlyAfterTaxComponent implements OnChanges {
  @Input() data: Returns
  @Input() profileData: any
  @Input() performanceFootNote: Footnote
  @Input() marketPriceFootNote: Footnote

  afterTaxReturns: AEMChunk
  aemContentSub: Subscription
  toggleValue = 'marketprice'
  type = 'regular'
  dialogTitle: string

  ngOnChanges(changes: any) {
    if (changes?.profileData && this.profileData?.isETF) {
      this.type = 'marketPrice'
    }
  }

  constructor(
    public viewContainer: ViewContainerRef,
    private readonly centralContentService: CentralContentService,
  ) {}

  ngOnInit() {
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  parseAEMContent(content) {
    this.afterTaxReturns = this.centralContentService.getContentByBody(
      'disclaimer_after_tax_returns',
      content,
    )
  }

  // eslint-disable-next-line complexity, max-statements
  onChange(event: string) {
    if (this.data !== null && this.data[event] !== undefined) {
      this.type = event
      if (event === 'marketPrice') {
        document
          .getElementById('QuarterlyMarket')
          ?.classList.add('c11n-segmented-control__segment--active')
        document
          .getElementById('Regular')
          ?.classList.remove('c11n-segmented-control__segment--active')
      } else {
        document
          .getElementById('Regular')
          ?.classList.add('c11n-segmented-control__segment--active')
        document
          .getElementById('QuarterlyMarket')
          ?.classList.remove('c11n-segmented-control__segment--active')
      }
    }
  }
}
